/* eslint-disable jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events */
import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

// components
import FilterColor from '@/braun/components/molecules/FilterColor';
import FilterCheckbox from '@/braun/components/molecules/FilterCheckbox';

const FilterItem = ({ filter, onChangeFilter }) => {
  const wrapperRef = useRef();
  const filterContentRef = useRef();
  const [isOpen, toggleOpen] = useState(false);
  const isColor = filter.code === 'baseColor';

  useEffect(() => {
    if (filterContentRef && filterContentRef.current) {
      if (!isOpen) {
        wrapperRef.current.removeAttribute('style');
      } else {
        wrapperRef.current.style.maxHeight = `${67 +
          filterContentRef.current.offsetHeight}px`;
      }
    }
  }, [isOpen]);

  return (
    <div
      ref={wrapperRef}
      className={`bra-toolbarPlp__accordion ${isOpen ? '-open' : ''}`}
    >
      <div
        className='bra-toolbarPlp__accordionHead'
        onClick={() => toggleOpen(!isOpen)}
      >
        <h3 className='bra-toolbarPlp__filterTitle'>{filter.name}</h3>
        <i
          className='bra-icn bra-icn__arrow--down'
          data-class=' bra-icn__arrow--down'
        />
      </div>
      <div ref={filterContentRef} className='bra-toolbarPlp__filterContent'>
        {filter.values.map(value =>
          isColor ? (
            <FilterColor
              key={value.code}
              value={value}
              onChange={onChangeFilter}
            />
          ) : (
            <FilterCheckbox
              key={value.code}
              value={value}
              filterCode={filter.code}
              onChange={onChangeFilter}
            />
          ),
        )}
      </div>
    </div>
  );
};

FilterItem.propTypes = {
  filter: PropTypes.shape(),
  onChangeFilter: PropTypes.func.isRequired,
};

FilterItem.defaultProps = {
  filter: {},
};

export default FilterItem;
